import { useAppSelector } from "@/store/hooks";
import { backgroundColors } from "@ai-teach/canvas-styles";
import type { LineElement } from "@ai-teach/types";
import { BiChevronLeft } from "react-icons/bi";
import { useSlideEditorContext } from "../SlideEditorContext";
import { StaticElement } from "../StaticElement";
import { DraggableLine } from "../renderers/DraggableLine";

export function FreeFormCanvasLiveMobileView() {
  const { slide, selectedId, canvasSize, scale } = useAppSelector(
    (state) => state.slideEditor.present
  );
  const { canvasRef } = useSlideEditorContext();

  if (!slide) return null;

  const elements = slide.elements;

  return (
    <div
      className="flex flex-col"
      style={{
        width: canvasSize.height * canvasSize.aspectRatio,
        // Same shared constant mobile's screen-wide background defaults to
        // (AiSpeakingBackdrop's LESSON_BASE_COLOR, "#FFF7DD") — reused rather than duplicated,
        // so the header row and the canvas share one continuous background with no white strip
        // between them.
        backgroundColor: backgroundColors.canvasBg,
      }}
    >
      {/* Lesson header — reserves its own space above the canvas, matching the real mobile
          PracticeScreen (a separate SafeAreaView above the canvas, not an overlay on top of it).
          An element authored at y=0 must render at the true top of the canvas box below, never
          underneath this. */}
      <div className="flex items-center justify-center h-16 px-3 shrink-0">
        <BiChevronLeft
          className="text-gray-600 rounded-full bg-white bg-opacity-50 mr-2"
          size={40}
        />
        <div className="relative bg-[#FFE89F] w-[80%] h-3 rounded-lg overflow-hidden">
          <div className="absolute left-0 h-3 w-[40%] bg-[#B8ECFF] rounded-lg" />
        </div>
      </div>

      <div
        ref={canvasRef}
        className="relative shadow-lg overflow-hidden"
        style={{
          height: canvasSize.height,
          aspectRatio: canvasSize.aspectRatio,
          transformOrigin: "center center",
          transform: `scale(${scale})`,
          backgroundColor: backgroundColors.canvasBg,
        }}
      >
        {/* Render non-line elements */}
        {elements
          .filter((el) => el.type !== "line")
          .map((element) => (
            <StaticElement key={element.id} element={element} />
          ))}

        {/* Render line elements */}
        {elements
          .filter((el) => el.type === "line")
          .map((element) => (
            <DraggableLine
              key={element.id}
              element={element as LineElement}
              isSelected={element.id === selectedId}
              scale={scale}
            />
          ))}
      </div>
    </div>
  );
}
